import script from "./AppMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=0742af8e&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=0742af8e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0742af8e"]])

export default __exports__